module.exports = __webpack_public_path__ + "img/horizontal_6_5_pp3_5010.65c4dec9.png";